// グローバルAjaxリクエストオブジェクト
var ajaxCity;
var ajaxSingleValidate;
var ajaxRelationValidate;
var ajaxGradeValidate;
var ajaxAllValidate;
var ajaxPostal1;
var ajaxPostal2;

/**
 * ブランドLP2（通信）フォームの初期化とイベント設定を行う
 */
function inquiryFormAction() {
	
	/**
	 * 入力値の全角英数字を半角に変換する
	 */
	$(".js-characters-change").on('change', function(e){
		var txt = $(this).val();
		var han = txt.replace(/[Ａ-Ｚａ-ｚ０-９]/g,function(s){return String.fromCharCode(s.charCodeAt(0)-0xFEE0)});
		han = han.replace(/[━.*‐.*―.*－.*\–.*ー.*\-]/gi,'');
		$(this).val(han);
	});

	/**
	 * 入力項目のblur時に個別バリデーションを実行する
	 */
	$('.js-inquiry-ajax-check').on('blur', function() {
		
		var target = $(this);
		var key = $(this).attr('name');
		var value = $(this).val();
		
		// nameのinquiry[]の文言を除去
		key = key.replace('inquiry[', '');
		key = key.replace(']', '');
		
		// ラジオボタンの場合は選択されている値を取得
		if ($(target).attr('type') == 'radio') {
			value = $('input[name=\'' + $(this).attr('name') + '\']:checked').val();
			if (value == undefined) {
				value = '';
			}
		}
		
		ajaxCheck(target, key, value);
	});
	
	// ライブバリデート続柄
	$('.js-inquiry-ajax-relationcheck-text').on('blur', function() {
		ajaxRelationCheck();
	});
	$('.js-inquiry-ajax-relationcheck-checkbox').on('change', function() {
		ajaxRelationCheck();
	});
	// 続柄 その他項目の出し分け
	$('.js-register_cd-toggle-etc').on('change', function() {
		toggleRegisterEtc();
	});

	/**
	 * 学年項目のblur時に学年バリデーションを実行する
	 */
	$('.js-inquiry-ajax-gradecheck').on('blur', function() {
		ajaxGradeCheck();
	});

	/**
	 * 教室チェック時に学年の再バリデーションを実行する
	 */
	$('.js-chk-kousha').on('change', function() {
		if ($('#grade').val() != '') {
			ajaxGradeCheck();
		}
	});
	
	/**
	 * 電話番号項目のblur時に電話番号バリデーションを実行する
	 */
	$('.js-inquiry-ajax-telcheck').on('blur', function() {
		if ($("#tel1").val() == "" || $("#tel2").val() == "" || $("#tel3").val() == "" || $(".tel1_err").children().length > 1 || $(".tel2_err").children().length > 1 || $(".tel3_err").children().length > 1 ) {
			$(".tel_err").children('p.inq-form-err').each(function() {$(this).remove();});
			$("#tel").removeClass("inquiryForm-error");
			var key = $(this).attr('name');
			key = key.replace('inquiry[', '');
			key = key.replace(']', '');
			ajaxCheck($(this), key, $(this).val());
		} else {
			ajaxTelCheck();
		}
	});

	/**
	 * 通塾の目的変更時にバリデーションを実行する
	 */
	$('.js-inquiry-ajax-purpose').on('change', function() {
		ajaxPurposeCheck()
	});
	
	/**
	 * 都道府県選択時に市区町村リストを取得する
	 */
	$('#pref_cd').on('change', function(){
		/**
		 * 市区町村プルダウンを初期化する
		 */
		$('#s_place_cd option').remove();
		$('#s_place_cd optgroup').remove();
		$('#s_place_cd').append($('<option>').html("市区町村を選択").val(""));
		
		/**
		 * Ajaxで市区町村リストを取得して設定する
		 */
		ajaxCity = $.ajax({
			type: "POST",
			url: "/city/get_combo_list_by_pref/"+$('#pref_cd').val()+"/",
			data: { is_json: 1}
		}).done(function( res ) {
			//市区町村プルダウンの選択を初期化
			$('#s_place_cd option').remove();
			$('#s_place_cd optgroup').remove();
			$('#s_place_cd').append($('<option>').html("市区町村を選択").val(""));
			for(var i in res.list){
				//市区町村項目を追加
				$('#s_place_cd').append($('<option id="' + res.list[i].City.s_place_cd + '">').html(res.list[i].City.s_place_name).val(res.list[i].City.s_place_cd));
			}
			//都道府県選択時にajaxで市区町村リスト更新後にchangeイベント発火
			$('[name="inquiry[s_place_cd]"]').trigger('change');
		});
		
	});
	
	/**
	 * 郵便番号入力時に7桁で住所検索を実行する
	 */
	$('.js-post').on('keyup', function() {
		var postal = $("#postal").val().replace(/[Ａ-Ｚａ-ｚ０-９]/g,function(s){return String.fromCharCode(s.charCodeAt(0)-0xFEE0)});
		if(postal.length == 7) {
			getAddressForPostal(postal);
		}
	});
	
	/**
	 * 入力項目フォーカス時にエラー表示をクリアする
	 */
	$('.js-inquiry-ajax-check,.js-inquiry-ajax-gradecheck,.js-inquiry-ajax-telcheck,.js-inquiry-ajax-relationcheck,.js-inquiry-ajax-purpose,.js-inquiry-ajax-relationcheck-text').on('focus', function() {
		deleteErrorMessage($(this));
	});
	
	// 性別選択時
	$("input[name='inquiry[sex]']").click(function(e) {
		// エラー削除
		clearSexError();
	});

	/**
	 * iPad向けに性別選択時のエラークリア処理を設定する
	 */
	if (navigator.userAgent.indexOf('iPad') > 0) {
		/**
		 * 性別選択時にエラー表示をクリアする
		 */
		$("input[name='inquiry[sex]']").on('click', function(e) {
			// エラー削除
			$("#sex_td").removeClass('inquiryForm-error');
			$('.sex_err').html('');
		});
	}
	
	/**
	 * 残り項目ボタンクリック時に全バリデーションを実行してエラー位置までスクロールする
	 */
	$('.js-error-scroll').on('click', function(e) {
		var data = $("form").serializeArray();
		ajaxAllValidate = $.ajax({
			type:'POST',
			url:"/brand_lp2_inquiry/ajax_validate_all/",
			data: { is_json: 1, 'validate_data':data}
		}).done(function( res ) {
			if (res.data != undefined) {
				var className = "";
				$.each(res.errors, function(i, val) { 
					className = i.replace("lp_inquiry_ajax_form.","");
					if ($("."+className+"_err").text() == "") {
						if (className == 'sex') {
							$("#"+className+"_td").addClass("inquiryForm-error");
						} else {
							$("#"+className).addClass("inquiryForm-error");
						}
						$("."+className+"_err").append('<p class="inq-form-err" >' + val + "</p>");
					}
				})
			}
			
			var anchour = $("#anchour").val();
			if (anchour == '' || anchour == 'undefined') {
				return;
			}
			var p = $('#' + anchour).offset().top;
			$('html,body').animate({ scrollTop: p }, 'fast');
		});
	});
	
	var confirmSubmit = 0;
	/**
	 * 確認画面ボタンクリック時にフォームを送信する
	 */
	$('.js-confirm-submit').on('click', function(e){
		if (confirmSubmit==0) {
			confirmSubmit = 1;
			// チェックボックスのついてる教室をsubmitする。
			// 1つもチェックがついてない場合はエラーとする。
			checkKousha = $("[class^='js-chk-kousha']:checked").map(function(){return $(this).val();}).get().join(',');
			
			if (checkKousha == '') {
				alert("教室を選択してください");
				confirmSubmit = 0;
				return ;
			}
			$('input').each(function(){
				var val = $(this).val();
				var placeholder = $(this).attr('placeholder');
				if (val == placeholder) {
					$(this).val('');
				}
			});
			if (ajaxCity) {
				ajaxCity.abort();
			}
			if (ajaxSingleValidate) {
				ajaxSingleValidate.abort();
			}
			if (ajaxRelationValidate) {
				ajaxRelationValidate.abort();
			}
			if (ajaxGradeValidate) {
				ajaxGradeValidate.abort();
			}
			if (ajaxAllValidate) {
				ajaxAllValidate.abort();
			}
			if (ajaxPostal1) {
				ajaxPostal1.abort();
			}
			if (ajaxPostal2) {
				ajaxPostal2.abort();
			}
			document.form1.submit();
			return true;
		} else {
			return false;
		}
	});
	
	/**
	 * 住所検索ボタンクリック時に郵便番号検索モーダルを開く
	 */
	$('.js-post-search').on('click', function() {
		ipop();
	});
	
	/**
	 * 住所検索機能のメソッドをオーバーライド。住所検索結果クリック時に郵便番号と住所をフォームにセットする
	 */
	$(document).on('click', '.add_select', function(){
		zipCd = $(this).attr('rel');
		$('#postal').val(zipCd);
		$('#postal').removeClass('inquiryForm-error');
		getAddressForPostal(zipCd);
		$('#ipop_close').trigger('click');
	});
	
	/**
	 * LocalStorageから保存されたフォーム入力値を復元する
	 */
	setRestoreFormValue();
}

/**
 * エラー文言を削除する
 * @param {object} target - バリデーション対象のjQueryオブジェクト
 */
function deleteErrorMessage(target) {
	
	let key = target.attr('name');
	key = key.replace('inquiry[', '');
	key = key.replace(']', '');
	$("." + key + "_err").children('p.inq-form-err').each(function() {$(this).remove();});
	
	// エラーの背景変更
	target.removeClass("inquiryForm-error");
}

/**
 * 個別項目のAjaxバリデーションを実行する
 * @param {object} target - バリデーション対象のjQueryオブジェクト
 * @param {string} key - バリデーション対象のキー名
 * @param {string} value - バリデーション対象の値
 */
function ajaxCheck(target, key, value) {

	ajaxSingleValidate = $.ajax({
		type:'POST',
		url:"/brand_lp2_inquiry/ajax_validate/",
		scriptCharset:"UTF-8",
		data: { is_json: 1, key:key, value:value}
	}).done(function( res ) {
		// エラー文言削除
		$("." + key + "_err").children('p.inq-form-err').each(function() {$(this).remove();});
		if (res.data != undefined) {
			// チェックエラーがある場合はエラーを表示
			$("." + key + "_err").append(res.data);
			
			// 背景を変更する時ラジオボタンの場合は親要素のtdにclass追加
			if ($(target).attr('type') == 'radio') {
				$(target).parents('td').addClass("inquiryForm-error");
			} else {
				$(target).addClass("inquiryForm-error");
			}
			confirmButtonDisplay();
		} else {
			// 背景を変更する時ラジオボタンの場合は親要素のtdからclass削除
			if ($(target).attr('type') == 'radio') {
				$(target).parents('td').removeClass("inquiryForm-error");
			} else {
				$(target).removeClass("inquiryForm-error");
			}
			confirmButtonDisplay();
		}
	});
}

/**
 * 続柄項目のAjaxバリデーションを実行する
 */
function ajaxRelationCheck() {
	var data = $("form").serializeArray();

	ajaxRelationValidate = $.ajax({
		type:'POST',
		url:"/brand_lp2_inquiry/ajax_validate_relation/",
		scriptCharset:"UTF-8",
		data: { is_json: 1,'validate_data':data}
	}).done(function( res ) {

		// 続柄チェック
		$(".register_cd_err").children('p.inq-form-err').each(function() {$(this).remove();});
		$(".register_etc_err").children('p.inq-form-err').each(function() {$(this).remove();});
		if (res.errors != undefined && res.errors['lp_inquiry_form_relation.register_cd'] != undefined) {
			// チェックエラーがある場合はエラーを表示
			message = '';
			if (Array.isArray(res.errors['lp_inquiry_form_relation.register_cd']) ) {
				message = res.errors['lp_inquiry_form_relation.register_cd'][0];
			} else {
				message = res.errors['lp_inquiry_form_relation.register_cd'];
			}
			$(".register_cd_err").append('<p class="inq-form-err" >' + message + "</p>");
			
			$('[name="inquiry[register_cd]"]').addClass("inquiryForm-error");
			confirmButtonDisplay();
		} else if (res.errors != undefined && res.errors['lp_inquiry_form_relation.register_etc'] != undefined) {
			// チェックエラーがある場合はエラーを表示
			message = '';
			if (Array.isArray(res.errors['lp_inquiry_form_relation.register_etc']) ) {
				message = res.errors['lp_inquiry_form_relation.register_etc'][0];
			} else {
				message = res.errors['lp_inquiry_form_relation.register_etc'];
			}
			$(".register_etc_err").append('<p class="inq-form-err" >' + message + "</p>");
			
			$('[name="inquiry[register_etc]"]').addClass("inquiryForm-error");
			confirmButtonDisplay();
		} else {
			$('[name="inquiry[register_cd]"]').removeClass("inquiryForm-error");
			$('[name="inquiry[register_etc]"]').removeClass("inquiryForm-error");
			confirmButtonDisplay();
		}
		
		// 続柄、学年相関チェック			
		if ($('#grade').val() != '') {
			$(".grade_err").children('p.inq-form-err').each(function() {$(this).remove();});
			if (res.errors != undefined && res.errors['lp_inquiry_form_relation.grade'] != undefined) {
				// チェックエラーがある場合はエラーを表示
				message = '';
				if ($.isArray(res.errors['lp_inquiry_form_relation.grade']) ) {
					message = res.errors['lp_inquiry_form_relation.grade'][0];
				} else {
					message = res.errors['lp_inquiry_form_relation.grade'];
				}
				$(".grade_err").append('<p class="inq-form-err" >' + message + "</p>");
				
				$("#grade").addClass("inquiryForm-error");
				confirmButtonDisplay();
			} else {
				$("#grade").removeClass("inquiryForm-error");
				confirmButtonDisplay();
			}
		}
	});
}

/**
 * 性別 エラー解除
 */
function clearSexError() {
	// エラー削除
	$('[name="inquiry[sex]"]').removeClass('inquiryForm-error');
	$('.sex_err').html('');
}

/**
 * 続柄 その他項目の出し分け
 */
function toggleRegisterEtc() {
	let registerCdValue = $('[name="inquiry[register_cd]"]:checked').val();
	if (registerCdValue == '006') {
		$('.js-register_etc-toggle').show();
	} else {
		$('.js-register_etc-toggle').hide();
	}
}

/**
 * 学年項目のAjaxバリデーションを実行する
 */
function ajaxGradeCheck() {
	var data = $("form").serializeArray();

	ajaxGradeValidate = $.ajax({
		type:'POST',
		url:"/brand_lp2_inquiry/ajax_validate_grade/",
		scriptCharset:"UTF-8",
		data: { is_json: 1,'validate_data':data}
	}).done(function( res ) {

		// エラー文言削除
		$(".grade_err").children('p.inq-form-err').each(function() {$(this).remove();});
		if (res.errors != undefined && res.errors['lp_inquiry_form_grade.grade'] != undefined) {
			// チェックエラーがある場合はエラーを表示
			message = '';
			if ($.isArray(res.errors['lp_inquiry_form_grade.grade']) ) {
				message = res.errors['lp_inquiry_form_grade.grade'][0];
			} else {
				message = res.errors['lp_inquiry_form_grade.grade'];
			}
			$(".grade_err").append('<p class="inq-form-err" >' + message + "</p>");
			
			$("#grade").addClass("inquiryForm-error");
			confirmButtonDisplay();
		} else {
			$("#grade").removeClass("inquiryForm-error");
			confirmButtonDisplay();
		}
	});
}

/**
 * 電話番号のAjaxバリデーションを実行する
 */
function ajaxTelCheck() {
	var data = $("form").serializeArray();
	var target = $("#tel").get(0);
	ajaxGradeValidate = $.ajax({
		type:'POST',
		url:"/brand_lp2_inquiry/ajax_validate_tel/",
		scriptCharset:"UTF-8",
		data: { is_json: 1,'validate_data':data}
	}).done(function( res ) {
		
		// エラー文言削除
		$(".tel_err").children('p.inq-form-err').each(function() {$(this).remove();});
		if (res.errors != undefined && res.errors['lp_inquiry_form_tel.tel'] != undefined) {
			// チェックエラーがある場合はエラーを表示
			message = '';
			if ($.isArray(res.errors['lp_inquiry_form_tel.tel']) ) {
				message = res.errors['lp_inquiry_form_tel.tel'][0];
			} else {
				message = res.errors['lp_inquiry_form_tel.tel'];
			}
			$(".tel_err").append('<p class="inq-form-err" >' + message + "</p>");
			
			$(target).addClass("inquiryForm-error");
			confirmButtonDisplay();
		} else {
			$(target).removeClass("inquiryForm-error");
			confirmButtonDisplay();
		}
	});
}

/**
 * 通塾の目的のAjaxバリデーションを実行する
 */
function ajaxPurposeCheck() {
	var data = $("form").serializeArray();

	ajaxGradeValidate = $.ajax({
		type:'POST',
		url:"/brand_lp2_inquiry/ajax_validate_purpose/",
		scriptCharset:"UTF-8",
		data: { is_json: 1,'validate_data':data}
	}).done(function( res ) {

		// エラー文言削除
		$(".purpose_err").children('p.inq-form-err').each(function() {$(this).remove();});
		if (res.errors != undefined && res.errors['lp_inquiry_form_purpose.purpose'] != undefined) {
			// チェックエラーがある場合はエラーを表示
			message = '';
			if ($.isArray(res.errors['lp_inquiry_form_purpose.purpose']) ) {
				message = res.errors['lp_inquiry_form_purpose.purpose'][0];
			} else {
				message = res.errors['lp_inquiry_form_purpose.purpose'];
			}
			$(".purpose_err").append('<p class="inq-form-err" >' + message + "</p>");
			
			// 背景を変更する時ラジオボタンの場合は親要素のtdにclass追加
			$("#purpose_td").addClass("inquiryForm-error");
			confirmButtonDisplay();
		} else {
			// 背景を変更する時ラジオボタンの場合は親要素のtdからclass削除
			$("#purpose_td").removeClass("inquiryForm-error");
			confirmButtonDisplay();
		}
	});
}

/**
 * 全項目の入力状況に応じて確認ボタンの表示を切り替える
 */
function confirmButtonDisplay() {
	var data = $("form").serializeArray();
	ajaxAllValidate = $.ajax({
		type:'POST',
		url:"/brand_lp2_inquiry/ajax_validate_all/",
		data: { is_json: 1, 'validate_data':data}
	}).done(function( res ) {
		if (res.data != undefined) {
			$("#input-error-count").text(res.dataCount);
			$("#anchour").val(res.scrollVal);
			$("#confirm-go-bt").css('display','none');
			$("#confirm_err-bt").css('display','block');
		} else {
			$("#confirm-go-bt").css('display','block');
			$("#confirm_err-bt").css('display','none');
		}
		
	});
}

/**
 * 郵便番号から住所情報を取得してフォームに設定する
 * @param {string} postal - 郵便番号(7桁)
 */
function getAddressForPostal(postal) {
	if (postal.length < '7') {
		return;
	}
	
	//ajaxで住所情報取得
	ajaxPostal1 = $.ajax({
		type: "POST",
		url: "/postal/get_data/" + postal,
		data: { is_json: 1}
	}).done(function( res ) {
		if (res.list == false) {
			return;
		}
		// エラー強調解除
		$('#pref_cd').removeClass('inquiryForm-error');
		$('#s_place_cd').removeClass('inquiryForm-error');
		$('#address1').removeClass('inquiryForm-error');
		$('#postal').removeClass('inquiryForm-error');
		$(".postal_err").children('p.inq-form-err').each(function() {$(this).remove();});
		$(".pref_cd_err").children('p.inq-form-err').each(function() {$(this).remove();});
		$(".s_place_cd_err").children('p.inq-form-err').each(function() {$(this).remove();});
		$(".address1_err").children('p.inq-form-err').each(function() {$(this).remove();});

		// 入力完了マーク
		$('#pref_cd_chk').css('display', 'inline');
		$('#s_place_cd_chk').css('display', 'inline');
		$('#postal_chk').css('display', 'inline');
		
		
		/**
		 * 取得した住所データから都道府県と市区町村を設定する
		 */
		// 都道府県設定
		var prefCd = res.list.City.pref_cd;
		var cityCd = res.list.Postal.s_place_cd;
		$('#pref_cd').val(prefCd);
		/**
		 * 市区町村プルダウンを取得して設定する
		 */
		ajaxPostal2 = $.ajax({
			type: "POST",
			url: "/city/get_combo_list_by_pref/" + prefCd,
			data: { is_json: 1}
		}).done(function( res ) {
			$('#s_place_cd option').remove();
			$('#s_place_cd optgroup').remove();
			$('#s_place_cd').append($('<option>').html("市区町村を選択").val(""));
			$('.js_loading_postal').remove();
			for (var i in res.list) {
				$('#s_place_cd').append($('<option label="' + res.list[i].City.s_place_name + '" value="' + res.list[i].City.s_place_cd +'">' + res.list[i].City.s_place_name + '</option>'));
				if (res.list[i].City.s_place_cd == cityCd) {
					$('#s_place_cd').children().last().prop('selected', true);
				}
			}
			//localstrage保存を行うためchangeイベント発火
			$('[name="inquiry[s_place_cd]"]').trigger('change');
			
		});
		// 町名・番地設定
		$('#address1').val(res.list.Postal.address2);
		$('#address1').focus();
		if ($('#address1').val() != '') {
			$('#address1_chk').css('display', 'inline');
		}
	});
}

/**
 * LocalStorageに保存されたフォームデータを復元する
 */
function setRestoreFormValue(){
	formData = getLocalStorageFormData('inquiry');

	var isExistCityData = false;
	if(formData !== null){
		$.each(formData, function(selector, item){
			if(item === '') return true;

			/**
			 * 項目タイプに応じて値を復元する
			 */
			//ラジオボタン・チェックボックス・市区町村以外はそのまま値を更新
			if($('[name="' + selector + '"]').attr('type') !== 'radio' && $('[name="' + selector + '"]').attr('type') !== 'checkbox' && selector.indexOf('s_place_cd') == -1) {
				$('[name="' + selector + '"]').val(item);
				//変更時にchangeイベントを発火
				$('[name="' + selector + '"]').trigger('change');

			//ラジオボタンの場合はチェックを付ける
			} else if($('[name="' + selector + '"]').attr('type') == 'radio') {
				$('[name="' + selector + '"][value=' + item + ']').attr('checked', true);
				if (selector.indexOf('register_cd') != -1) {
					// 続柄 その他枠の出し分け
					toggleRegisterEtc();
				} else if (selector.indexOf('sex') != -1) {
					// 性別エラー解除
					clearSexError();
				}
			
			//チェックボックスの場合はチェックを付ける
			} else if($('[name="' + selector + '"]').attr('type') == 'checkbox') {
				// 配列でチェックを入れる
				if (item != undefined && item.constructor == Array) {
					$.each(item, function(key, val){
						$('[name="' + selector + '"][value=' + val + ']').attr('checked', true);
					})
				}
				//変更時にchangeイベントを発火
				$('[name="' + selector + '"]').trigger('change');

			//市区町村の場合（都道府県読み込み後に値を入れる）
			} else if( selector.indexOf('s_place_cd') != -1 ){
				isExistCityData = true;
				//Localstorageから値を入れるのは読み込み一度限りなので発火後イベントは削除
				$('[name="' + selector + '"]').on('change.storageDataApply', function(){
					$(this).val(item);
					//自分のイベント解除
					$(this).off('change.storageDataApply');
					$(this).trigger('change');
					//blurを発火させ未入力アラートを更新
					$('[name="' + selector + '"]').trigger('blur');
				});
			}
		});
		//blurを発火させ未入力アラートを更新（市区町村の値が入っている場合はajax取得後に更新）
		if(isExistCityData == false) {
			$('[name="' + Object.keys(formData).pop() + '"]').trigger('blur');
		}
	}
}

/**
 * ページロード後にフォーム処理を初期化する
 */
$(function(){
	inquiryFormAction();

	// カナ自動入力
	$.fn.autoKana('#name1', '#kana1', {
		katakana : false//true：カタカナ、false：ひらがな（デフォルト）
	});
	$.fn.autoKana('#name2', '#kana2', {
		katakana : false//true：カタカナ、false：ひらがな（デフォルト）
	});
	
	// エラーがある場合
	if ($("#error_count").val() > 0) {
		alert('未入力項目が' + $("#error_count").val() + '個あります');
	} else {
		$('#register_cd_td','input[value="001"]').focus();
	}
	confirmButtonDisplay();
	if ($("#error_count").val() > 0) {
		var anchour = $("#anchour").val();
		var p = $('#' + anchour).offset().top;
		$('html,body').animate({ scrollTop: p }, 'fast');
	}
});